/**
 * External Dependencies
 */

// https://discourse.roots.io/t/sage-10-and-js-routing/19020

import LazyLoad from 'vanilla-lazyload';
import oldBrowser from './tools/old-browser';
import CookieBar from './tools/cookie-bar';
import './tools/responsive';
import './tools/scrollToSection';
import './helpers';
import { SiteHeaderMenu } from './components/SiteHeader';
import { Tham } from './components/Tham';
import { WebUI } from './components/WebUI';
import SliderFactory from './components/Slider';
import {Countup} from "./components/Countup";
import {AnimateOnScroll} from "./components/AnimateOnScroll";
import SimpleParallax from "./components/SimpleParallax";


// import Alpine from 'alpinejs'
// import 'jquery';

// $(document).ready(() => {
//   // console.log('Hello world');
// });

document.addEventListener("DOMContentLoaded", function() {
    // Lazyload
    let lazyLoad = new LazyLoad({
        elements_selector: '[data-lazy]',
        load_delay: 300,
    });

    // Check Modern/Old Browser
    const checkBrowser = new oldBrowser();
    checkBrowser.init();

    // Cookiebar
    const _CookieBar = new CookieBar();
    _CookieBar.init();

    //Header
    const _siteHeaderMenu = new SiteHeaderMenu();
    const _webUI = new WebUI();
    const _tham = new Tham();
    const _animationOnScroll = new AnimateOnScroll();
    const _parralax = new SimpleParallax();

    const _countsup = new Countup();

    _tham.subscribe(menuState => {
      _webUI.documentBodyFreeze();
      _siteHeaderMenu.toogleMobileMenu(menuState);
    });

    _webUI.scrollSubscribe((scrollDepth,w,y) => {
      _siteHeaderMenu.onScroll(scrollDepth);
      _countsup.onScroll(scrollDepth, w, y);
      _animationOnScroll.onScroll(scrollDepth,w,y);
      _parralax.onScroll(scrollDepth);
    })

    _webUI.scrollDepth();

    _siteHeaderMenu.subscribe(menuClick => {
        _tham.toogleThamState();
        _webUI.documentBodyFreeze(false);
    });

    const _sliders = new SliderFactory();
    _sliders.init();

});
